export default () => ({
  id: null,
  email: '',
  role: '',
  isDemo: false,
})
